module.exports = __webpack_public_path__ + "public/img/mp_code.0fc0c149.png";